import { Component } from '@angular/core';
import {PlayerActivity} from "../../entities/players/PlayerActivity";
import {APIService} from "../../services/APIService";
import {PlayerBoothActivity} from "../../entities/players/PlayerBoothActivity";
import {Punishment} from "../../entities/players/Punishment";
import {MatDialog} from "@angular/material/dialog";
import {QuashDialogueComponent} from "./quash-dialogue/quash-dialogue.component";
import {AuthService} from "../../services/AuthService";

@Component({
  selector: 'app-staff-activity',
  templateUrl: './punishments.component.html',
  styleUrls: ['./punishments.component.css']
})
export class PunishmentsComponent {

  columns: string[] = ['player', 'mod', 'type', 'reason', 'status']
  punishments: Punishment[] = [];
  active: boolean = true;

  constructor(protected apiService: APIService,
              protected authService: AuthService,
              private dialog: MatDialog) {
    this.refresh(true);
  }

  refresh(active: boolean) {
    this.active = active;
    this.apiService.getPunishments(active).then((p) => this.punishments = p);
  }

  isActive(punishment: Punishment): boolean {
    if(punishment.quashed)
      return false;
    const ends = Date.parse(punishment.ends!);
    return ends > Date.now();
  }

  quash(punishment: Punishment) {
    /*const dialogRef = this.dialog.open(QuashDialogueComponent, {
      data: punishment,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.apiService.quashPunishment(punishment.id)
          .then((a) => this.refresh(this.active));
      }
    });*/
  }

  getStatus(punishment: Punishment): string {
    if(punishment.quashed)
      return "Quashed";
    if(!punishment.active)
      return "Expired";
    if(punishment.ends === undefined)
      return "Permanent";
    const ends = Date.parse(punishment.ends!);
    if(ends > Date.now())
      return "Ends " + punishment.ends!;
    return "Expired";
  }
}
